// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MultiSelect_wrapper__2fzat","root":"MultiSelect_root__1qntT","error":"MultiSelect_error__-SrrE"};